<button
  class="mobile-menu-button"
  type="button"
  (click)="open()"
>
  MENU
</button>

<section
  class="mobile-menu"
  [class.mobile-menu--visible]="opened()"
>
  <a
    class="mobile-menu__title"
    routerLink="/"
    (click)="close()"
  >
    DARIA SOLOVEVA
  </a>

  <nav class="mobile-menu__nav">
    <a
      routerLink="/about"
      (click)="close()"
    >
      ABOUT
    </a>

    <a
      routerLink="/contact"
      (click)="close()"
    >
      CONTACT
    </a>
  </nav>

  <button
    class="mobile-menu__close"
    type="button"
    (click)="close()"
  >
    CLOSE
  </button>
</section>
